module.exports = __webpack_public_path__ + "static/media/cl_trade_arrow_grey.75a97fcd.svg";